
import { defineComponent } from "vue";

import { useLeaderboard } from "@/hooks";

import {nameToURL} from '@/helpers'

import RaceCard from '@/components/Races/Card.vue'

export default defineComponent({
  setup() {
    return {races: useLeaderboard(), nameToURL};
  },
  name: "Race List",
  components: {RaceCard},
});
